import React from 'react';

import { AmountInput } from './components/AmountInput';
import { ImpressionAmountButton } from './components/ImpressionAmountButton';
import { ValidationError } from './components/ValidationError';
import { useImpressionAmountSelector } from './hooks/useImpressionAmountSelector';

export function ImpressionAmountSelector(): React.JSX.Element {
	const {
		data: { amountChoices, ref },
	} = useImpressionAmountSelector();

	return (
		<div data-testid="promotion-impression-amount-selector" className="flex flex-col gap-3" ref={ref}>
			<ValidationError />
			{amountChoices.map((buttonAmount) => (
				<ImpressionAmountButton key={buttonAmount} buttonAmount={buttonAmount} />
			))}
			<AmountInput />
		</div>
	);
}
